export const FETCH_START = 'IMP/FETCH_START';
export const fetchStart = () => ({
  type: FETCH_START,
});
export const FETCH_END = 'IMP/FETCH_END';
export const fetchEnd = () => ({
  type: FETCH_END,
});
export const FETCH_ERROR = 'IMP/FETCH_ERROR';
export const fetchError = () => ({
  type: FETCH_ERROR,
});
export const FETCH_CANCEL = 'IMP/FETCH_CANCEL';
export const fetchCancel = () => ({
  type: FETCH_CANCEL,
});
